import { gql } from '@apollo/client'

import { NOTIFICATION_FIELDS_FRAGMENT } from '../fragments'

// Not sure this is used
const EVENT_NOTIFICATIONS_QUERY = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}

  query ($whereNotifications: QueryNotificationsWhereWhereConditions) {
    notifications(where: $whereNotifications) {
      ...NotificationFields
    }
  }
`

// Not sure this is used
const NOTIFICATIONS_QUERY = gql`
  ${NOTIFICATION_FIELDS_FRAGMENT}

  query {
    me {
      id
      unreadNotificationCount
      myNotifications {
        ...NotificationFields
      }
    }
  }
`

export { EVENT_NOTIFICATIONS_QUERY, NOTIFICATIONS_QUERY }
